import { AccountDetailsDTO, AccountDTO, AccountRegType, UserOAuthConnection } from '../data';

export type CheckSessionReqQuery = {
  token?: string;
};

export type CheckSessionResp = {
  email: string;
  token: string;
  accountId: string;
};

export type SetInitialPasswordReqBody = {
  token: string;
  currentPassword?: string;
  newPassword?: string;

};

export type StartForgottenPasswordReqBody = {
  email: string;
};

export type SetPasswordReqBody = {
  accountId: string;
  newPassword: string;
  // token?: string;
};

export type ConfirmEmailReqBody = {
  token: string;
};

export type UpdateAccountReqBody = {
  accountId: string;
  name?: string;
  email?: string;
  withOtp?: boolean;
  withEmailValidation?: boolean;
};

export type ChangeEmailReqBody = {
  accountId: string;
  email: string;
};

export type DeleteAccountReqBody = {
  accountId: string;
};

export type DisconnectOauthAccountReqBody = {
  accountId: string;
  provider: keyof UserOAuthConnection;
};

export type ConnectOauthAccountReqBody = {
  accountId: string;
  provider: keyof UserOAuthConnection;
  socialId: string;
};

export type BackofficeQueryBody = {
  regType: AccountRegType;
  emailAddress?: string;
  accountName?: string;
  customerId?: string;
  phoneNumber?: string;
};

export type BackofficeQueryResponse = {
  totalCount: number;
  accountList: Array<AccountDetailsDTO>;
};

export type BackofficeQuery4RegistrationDataResponse = {
  name: string;
  totalContactCount: number;
  EmailContactList: Array<{
    contactName: string;
    contactEmail: string;
  }>;
};


export type BackofficeReasonBody = {
  reason: 'User' | 'Operator';
  comment: string;
};

export type BackofficeAddSubscriptionReqBody = {
  subscriberNumber: string;
};

export type BackofficeAddSubscriptionByPhoneNumberReqBody = {
  phoneNumber: string;
};

export type BackofficeLostEmailReqBody = {
  email: string;
};

export type BackofficeChangeEmailReqBody = {
  email: string;
}

export type BackofficeLostEmailOtpReqBody = {
  otp: string;
};

export type ResetPasswordReqBody = {
  email: string;
};

export type LockAccountReqBody = {
  reason: LockReasonType;
};

export type UnlockAccountReqBody = {
  reason: LockReasonType;
};

export enum RegistrationMode {
  Default = 'default',
  Password = 'password',
  Yolo = 'yolo',
}
export type CaptchaTokenReqBody = {
  ct?: string;
};
export type RegisterAccountReqBody = CaptchaTokenReqBody & {
  mode: RegistrationMode.Default | RegistrationMode.Password | RegistrationMode.Yolo;
  name: string;
  email: string;
  password: string;
};

export type RegisterAccountB2bReqBody = {
  email: string;
  customerId: string;
  name: string;
}

export type RegisterAccountB2bFinalizeReqQuery = {
  email?: string;
};

export type RegisterAccountB2bCompleteReqBody = {
  email: string;
  otp: string;
  password: string;
}

export type searchCustomerContactPhoneNumbersReqQuery = {
  email?: string;
};

export type searchCustomerContactPhoneNumbersRespBody = {
  phoneNumberList: string[];
};

export type searchCustomerContactPhoneNumbersByCAReqQuery = {
  customer?: string;
};

export type searchCustomerContactPhoneNumbersByCARespBody = {
  phoneNumberList: string[];
};

export type RegisterAccountResp = {
  accountId: string;
}

export type OTPConfirmReqBody = {
  accountId: string;
  otp: string;
}

export type OTPConfirmWithEmailReqBody = {
  email: string;
  otp: string;
}

export enum LockReasonType {
  Unknown = 'Unknown', //Ismeretlen
  User = 'User', //Ügyfél művelet eredménye
  System = 'System', //Rendszer művelet eredménye
  Operator = 'Operator', //Ügyintézői művelet eredménye
}

export type MFACheckSmsNumberReqBody = {
  phoneNumber: string;
};

export type MFAStoreSmsNumberReqBody = {
  phoneNumber: string;
};

export type MFACreateQrCodeReqBody = {
  authenticatorName: string;
  email: string;
};

export type MFAStoreQrCodeReqBody = {
  totpUrl: string;

};

export type MFACreateQrCodeResponse = {
  secret: string;
  totp: string;
  encoded: string;
};

export type TotpConnectReqBody = {
  totpUrl: string;
};

export enum RedirectType {
  Normal = 'Normal',
  B2bRegister = 'B2bRegister',
}

export type SmsConnectReqBody = {
  phoneNumber: string;
  redirectType: RedirectType;
};

export type AccountConnectReqBody = {
  referer: string;
};

export type LoginUrlResp = {
  url: string;
  error?: string;
};

export type SubscriptionIdReqBody = {
  subscriptionId: string;
};

export type CustomerIdReqBody = {
  customerId: string;
};

export type BlockEmailChangeReqQuery = {
  sessionId: string;
};

export type ConfirmEmailResp = {
  account: AccountDTO;
  isRegistrationFlow: boolean;
}

export type ResendOtpReqBody = {
  accountId: string;
};

export type IdentificationReqBody = {
  externalId: string;
  scenario: string;
  locale: string;
  resultRedirectUrlOk: string;
  resultRedirectUrlNoOk: string;
};

export type FourTData = {
  familyName: string;
  givenName: string;
  dateOfBirth: string;
  placeOfBirth: string;
  mothersName: string;
};

export type GetIdentityResp = {
  idType: string;
  idNumber: string;
  fourTData: FourTData;
};

export type ValidateIdentityReqBody = {
  idType: string;
  idNumber: string;
  fourTData: FourTData;
};

export type ValidateIdentityResp = {
  isSuccess: boolean;
  UI_Error_MessageHU?: string;
  UI_Error_MessageGB?: string;
};

export type SearchCustomerBy4TResp = {
  result: {
    customerId?: string;
    name?: string;
    phoneNumber?: string[];
  };
}